import React from 'react';
import styled from 'styled-components';

import RevenueMainOptionsBar from '../../../../../containers/dashboards/cards/builder/revenue/RevenueMainOptionsBar';
import RevenuePaymentFilterModal from '../../../../../containers/dashboards/cards/builder/revenue/RevenuePaymentFilterModal';
import RevenueOptionBar from '../../../../../containers/dashboards/cards/builder/revenue/RevenueOptionsBar';

const RevenueViewContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  position: relative;

  .main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
  }

  .options-bar-container {
    margin-bottom: 15px;
  }

  .payment-modal-container {
    margin: 10px 0;
    display: flex;
  }
`;

const RevenueView = ({ unit }) => {
  return (
    <RevenueViewContainer>
      <div className="main">
        <div className="options-bar-container">
          <RevenueMainOptionsBar unit={unit} />
        </div>
        <div className="payment-modal-container">
          <RevenuePaymentFilterModal unit={unit} />
        </div>
        <RevenueOptionBar unit={unit} />
      </div>
    </RevenueViewContainer>
  );
};

export default RevenueView;
